import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import './assets/css/index.scss'
import i18n from './i18n'
import store from './store'

const app = createApp(App)
app.use(router) //注册路由
app.use(ElementPlus) //注册Element Plus
app.use(i18n) //注册国际化
app.use(store) //注册Vuex
app.mount('#app')
